import { TIP_ACTION_TYPES } from '../actions/types';

const initialState = {
  messageTipsEarnings: null,
  messageTipsEarningsSubscriberId: null,
  messageTipsEarningsLoading: false,
  messageTipsEarningsError: null,
};

const tipReducer = (state = initialState, action) => {
  switch (action.type) {
    case TIP_ACTION_TYPES.FETCH_MESSAGE_TIPS_EARNINGS_REQUEST:
      return {
        ...state,
        messageTipsEarningsLoading: true,
        messageTipsEarningsError: null,
      };

    case TIP_ACTION_TYPES.FETCH_MESSAGE_TIPS_EARNINGS_SUCCESS:
      return {
        ...state,
        messageTipsEarningsLoading: false,
        messageTipsEarnings: action.payload.data,
        messageTipsEarningsSubscriberId: action.payload.subscriberId ?? null,
        messageTipsEarningsError: null,
      };

    case TIP_ACTION_TYPES.FETCH_MESSAGE_TIPS_EARNINGS_FAILURE:
      return {
        ...state,
        messageTipsEarningsLoading: false,
        messageTipsEarningsError: action.payload,
      };

    case TIP_ACTION_TYPES.CLEAR_TIP_ERRORS:
      return {
        ...state,
        messageTipsEarningsError: null,
      };

    default:
      return state;
  }
};

export default tipReducer;
